import React from 'react';
import { useTheme, getThemeClasses } from '../context/ThemeContext';

export default function BookCardSkeleton() {
  const { theme } = useTheme();
  const themeClasses = getThemeClasses(theme);
  
  return (
    <div className={`${themeClasses.card} rounded-xl shadow-md overflow-hidden animate-pulse`}>
      <div className="sm:flex">
        <div className="w-full sm:w-1/4">
          <div className={`h-44 sm:h-full ${themeClasses.secondary}`} />
        </div>
        <div className="p-4 sm:w-3/4 space-y-4">
          <div className={`h-6 ${themeClasses.secondary} rounded w-3/4`} />
          <div className={`h-4 ${themeClasses.secondary} rounded w-1/2`} />
          <div className="space-y-2">
            <div className={`h-4 ${themeClasses.secondary} rounded`} />
            <div className={`h-4 ${themeClasses.secondary} rounded`} />
            <div className={`h-4 ${themeClasses.secondary} rounded w-5/6`} />
          </div>
          <div className="flex gap-2">
            <div className={`h-8 w-32 ${themeClasses.secondary} rounded-lg`} />
            <div className={`h-8 w-32 ${themeClasses.secondary} rounded-lg`} />
          </div>
        </div>
      </div>
    </div>
  );
}